<app-contact-cards-slider>
  @for (item of data; track item.id) {
    <app-contact-cards-slider-item [name]="item.name" [position]="item.position" [email]="item.email" [phone]="item.phone ?? undefined" [photo]="item.photo?.cdnUrl"></app-contact-cards-slider-item>
  }
</app-contact-cards-slider>